import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { TranslationTextBox, TranslationTextBoxProps} from "../../core/components/translationTextBox";
import { FieldInstance } from "../../core/components/field";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditShippingMethods extends React.Component<EditShippingMethodsProps, EditShippingMethodsState> {
    private _factory = ComponentHelper.createFactory();
    private _translations: string[] = [];
    private _gridOptions = null;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    let isValid = Helper.hasValue(this.state.currentShippingMethod.Translations) && this.state.currentShippingMethod.Translations.filter((f: any) => !Helper.isNullOrEmpty(f.Value)).length > 0;
                    if (isValid) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._closeDialog();
        },
        width: 500
    };

    constructor(props: EditShippingMethodsProps) {
        super(props);
        this._gridOptions = props.context.shippingMethodsGridOptions;
        this._translations = props.context.translations;
        this.state = {
            gridData: [],
            dialogOpen: false,
            enableDeleteButton: false,
            currentShippingMethod: null
        };    
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={true} >
                    {this._createTextBox()}
                </Dialog>
            </div>
        );
    }

    private _createTextBox = () => {
        let props: TranslationTextBoxProps = this._factory.getDefaultTranslationTextBoxProps();
        props.language = "Key";
        props.translation = "Value";
        props.value = this.state.currentShippingMethod.Translations;

        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let shippingMethod = this.state.currentShippingMethod;
            shippingMethod.Translations = value;
            this.setState({ currentShippingMethod: shippingMethod });
        }

        return (
            <FieldInstance label={this._translations["Standard.Name"] + "*"} noHover={true}>
                <TranslationTextBox {...props} />
            </FieldInstance>
        );

    }


    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _openDialog = (dataItem: ShippingMethod = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: -1,
                IsDeletable: true,
                IsNew: true,
                Translations: null,
                DisplayName: ""
            }
        }
        this.setState({
            dialogOpen: true,
            currentShippingMethod: dataItem
        });
    }

    private _save = () => {
        HTTPService.post<JsonResultClass>("AddressSettings/SaveShippingMethod", { model: this.state.currentShippingMethod})
            .then(result => {
                if (result.Code == 0) {
                    this._getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _delete = (dataItem: ShippingMethod) => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("AddressSettings/DeleteShippingMethod", { model: dataItem })
                    .then(result => {
                        if (result.Code == 0) {
                            this._getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }
    
    private _getGridData = () => {
        const url = "AddressSettings/GetShippingMethods";
        HTTPService.get<JsonResultClass<[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });
        let grid = (
            <Grid data={this.state.gridData} options={this._gridOptions} id="GeneralSettings_Addresses_ShippingMethodsGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                onSelectionChanged={this._onSelectionChanged} />
        );
        return (
            <div style={{ height: "300px" }}>
                {grid}
            </div>
        );
    }

    private _onSelectionChanged = (dataItem: ShippingMethod) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable });
        } else {
            this.setState({ enableDeleteButton: false });
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: ShippingMethod) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem);
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog();
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface EditShippingMethodsProps {
    context: ContextGeneralSettingsApp;
}

interface EditShippingMethodsState {
    gridData: ShippingMethod[];
    dialogOpen: boolean;
    enableDeleteButton: boolean;
    currentShippingMethod: ShippingMethod;
}

interface ShippingMethod {
    Id: number;
    DisplayName: string;
    Translations: [];
    IsDeletable: boolean;
    IsNew: boolean;
}
